<template>
  <modal v-model="openModel" max-width="650">
    <template #title>Publish Revision</template>
    <template #content>
      <div class="text-center">
        <p>Please specify the outcome of this revision:</p>
        <option-list v-model="selectedOutcome">
          <option-list-item
            v-for="option in outcomeOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.text }}
          </option-list-item>
        </option-list>
        <v-alert
          v-if="hasPending"
          class="mt-6"
          type="warning"
          dense
          outlined
        >
          References that haven't been fully reviewed will be carried
          over.
        </v-alert>
      </div>
    </template>
    <template #actions>
      <action-button class="mr-3" @click="openModel = false">
        Cancel
      </action-button>
      <action-button
        :disabled="!selectedOutcome"
        :loading="publishing"
        color="primary"
        @click="publishRevision"
      >
        Publish
      </action-button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/Common/Modal';
import OptionList from '@/components/Common/OptionList';
import OptionListItem from '@/components/Common/OptionListItem';
import ActionButton from '@/components/Common/ActionButton';
import { RevisionOutcome } from '@/enums';

export default {
  name: 'RevisionPublishModal',
  components: {
    Modal,
    OptionList,
    OptionListItem,
    ActionButton,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    hasPending: {
      type: Boolean,
      default: false,
    },
    hasIncluded: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:open', 'publish-revision'],
  data: () => ({
    selectedOutcome: null,
    publishing: false,
  }),
  computed: {
    openModel: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit('update:open', value);
      },
    },
    outcomeOptions() {
      const maybeNoNewEvidenceOption = [];
      if (!this.hasIncluded) {
        maybeNoNewEvidenceOption.push({
          text: 'No new evidence',
          value: RevisionOutcome.NO_NEW_EVIDENCE,
        });
      }
      return [
        ...maybeNoNewEvidenceOption,
        {
          text: 'Evidence found, no impact',
          value: RevisionOutcome.NEW_EVIDENCE_NO_IMPACT,
        },
        {
          text: 'Impactful evidence found, integrate',
          value: RevisionOutcome.NEW_EVIDENCE_IMPACTFUL,
        },
      ];
    },
  },
  watch: {
    open(open) {
      if (open) {
        this.selectedOutcome = null;
        this.publishing = false;
      }
    },
  },
  methods: {
    publishRevision() {
      this.$emit('publish-revision', this.selectedOutcome);
      this.publishing = true;
    },
  },
};
</script>
